"use strict";

angular.module("customer")
.service("PartnershipService", function($resource, appConfig) {
    var partnershipNewService = $resource(appConfig.API_SERVER + "/auth/customer/partnerships/", {}, {
        save: {
            method: "POST"
        }
    });

    this.add = function(data) {
        var partnership = new partnershipNewService(data);
        return partnership.$save();
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/partnership/partnership.service.js
// module id = 813
// module chunks = 0